export default "__VITE_ASSET__3466bba8__"